var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['container', _vm.contentClass]},[_c('div',{staticClass:"background-img"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.firstLine))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.secondLine))])])
}
var staticRenderFns = []

export { render, staticRenderFns }